// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Summary Page */
.summary-container {
    max-width: 900px;
    margin: 2rem auto;
    padding: 2rem;
    background-color: #fff;
    border-radius: 12px;
    box-shadow: 0px 4px 12px rgba(0, 0, 0, 0.1);
}

h2 {
    text-align: center;
    font-size: 2rem;
    color: var(--clr-primary-4);
    margin-bottom: 2rem;
}

.back-button {
    background-color: var(--clr-primary-5);
    color: white;
    border: none;
    padding: 0.75rem 1.5rem;
    border-radius: 8px;
    cursor: pointer;
    transition: background-color 0.3s ease;
    margin-bottom: 1.5rem;
}

.back-button:hover {
    background-color: var(--clr-primary-3);
}

.summary-section {
    margin-bottom: 2rem;
}

h3 {
    font-size: 1.5rem;
    color: var(--clr-primary-3);
    margin-bottom: 1rem;
}

/* Action Log List */
.action-log-list {
    list-style-type: none;
    padding: 0;
}

.log-entry {
    background-color: #f4f7f9;
    padding: 1.5rem;
    margin-bottom: 1rem;
    border-left: 5px solid var(--clr-primary-3);
    border-radius: 8px;
    transition: background-color 0.3s ease, box-shadow 0.3s ease;
}

.log-entry:hover {
    background-color: #eef2f7;
    box-shadow: 0px 4px 8px rgba(0, 0, 0, 0.05);
}

.log-entry.cancelled {
    background-color: #ffe6e6;
    border-left: 5px solid #ff5c5c;
}

.log-details p {
    margin: 0.5rem 0;
}

.log-details strong {
    color: var(--clr-primary-3);
}

/* View Log Button */
.view-log-button {
    background-color: var(--clr-primary-5);
    color: white;
    border: none;
    padding: 10px 20px;
    cursor: pointer;
    border-radius: 8px;
    margin-top: 1.5rem;
    transition: background-color 0.3s ease;
}

.view-log-button:hover {
    background-color: var(--clr-primary-3);
}

/* Modal Styles */
.modal {
    position: fixed;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    z-index: 1000;
    background-color: white;
    padding: 2rem;
    border-radius: 10px;
    box-shadow: 0px 8px 24px rgba(0, 0, 0, 0.2);
    width: 60%;
    max-height: 70vh;
    overflow-y: auto;
}

.modal-content {
    flex-grow: 1;
    padding: 1rem;
}

.modal ul {
    list-style: none;
    padding: 0;
    margin: 0;
}

.modal ul li {
    padding: 10px;
    border-bottom: 1px solid #eee;
}

.close-button {
    background-color: #ff5c5c;
    color: white;
    border: none;
    padding: 8px 12px;
    cursor: pointer;
    border-radius: 50%;
    font-size: 1.2rem;
    position: absolute;
    top: 15px;
    right: 15px;
}

.close-button:hover {
    background-color: #ff8787;
}

.modal-overlay {
    position: fixed;
    top: 0;
    left: 0;
    width: 100vw;
    height: 100vh;
    background: rgba(0, 0, 0, 0.5);
    z-index: 999;
}

.recent-log-entry {
    background-color: var(--clr-primary-10);
    border-left: 4px solid var(--clr-primary-5);
  }

  
/* Responsive Design */
@media (max-width: 768px) {
    .modal {
        width: 90%;
        max-height: 80vh;
    }

    .summary-container {
        padding: 1rem;
    }

    .view-log-button, .back-button {
        padding: 0.75rem 1rem;
    }
}

@media (max-width: 768px) {
    .close-button {
        width: 10%;
    }
}

@media (max-width: 480px) {
    .close-button {
        width: 10%;
    }
}`, "",{"version":3,"sources":["webpack://./src/components/Scheduling/styles/summaryContainer.css"],"names":[],"mappings":"AAAA,iBAAiB;AACjB;IACI,gBAAgB;IAChB,iBAAiB;IACjB,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,2CAA2C;AAC/C;;AAEA;IACI,kBAAkB;IAClB,eAAe;IACf,2BAA2B;IAC3B,mBAAmB;AACvB;;AAEA;IACI,sCAAsC;IACtC,YAAY;IACZ,YAAY;IACZ,uBAAuB;IACvB,kBAAkB;IAClB,eAAe;IACf,sCAAsC;IACtC,qBAAqB;AACzB;;AAEA;IACI,sCAAsC;AAC1C;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,iBAAiB;IACjB,2BAA2B;IAC3B,mBAAmB;AACvB;;AAEA,oBAAoB;AACpB;IACI,qBAAqB;IACrB,UAAU;AACd;;AAEA;IACI,yBAAyB;IACzB,eAAe;IACf,mBAAmB;IACnB,2CAA2C;IAC3C,kBAAkB;IAClB,4DAA4D;AAChE;;AAEA;IACI,yBAAyB;IACzB,2CAA2C;AAC/C;;AAEA;IACI,yBAAyB;IACzB,8BAA8B;AAClC;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,2BAA2B;AAC/B;;AAEA,oBAAoB;AACpB;IACI,sCAAsC;IACtC,YAAY;IACZ,YAAY;IACZ,kBAAkB;IAClB,eAAe;IACf,kBAAkB;IAClB,kBAAkB;IAClB,sCAAsC;AAC1C;;AAEA;IACI,sCAAsC;AAC1C;;AAEA,iBAAiB;AACjB;IACI,eAAe;IACf,QAAQ;IACR,SAAS;IACT,gCAAgC;IAChC,aAAa;IACb,uBAAuB;IACvB,aAAa;IACb,mBAAmB;IACnB,2CAA2C;IAC3C,UAAU;IACV,gBAAgB;IAChB,gBAAgB;AACpB;;AAEA;IACI,YAAY;IACZ,aAAa;AACjB;;AAEA;IACI,gBAAgB;IAChB,UAAU;IACV,SAAS;AACb;;AAEA;IACI,aAAa;IACb,6BAA6B;AACjC;;AAEA;IACI,yBAAyB;IACzB,YAAY;IACZ,YAAY;IACZ,iBAAiB;IACjB,eAAe;IACf,kBAAkB;IAClB,iBAAiB;IACjB,kBAAkB;IAClB,SAAS;IACT,WAAW;AACf;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,eAAe;IACf,MAAM;IACN,OAAO;IACP,YAAY;IACZ,aAAa;IACb,8BAA8B;IAC9B,YAAY;AAChB;;AAEA;IACI,uCAAuC;IACvC,2CAA2C;EAC7C;;;AAGF,sBAAsB;AACtB;IACI;QACI,UAAU;QACV,gBAAgB;IACpB;;IAEA;QACI,aAAa;IACjB;;IAEA;QACI,qBAAqB;IACzB;AACJ;;AAEA;IACI;QACI,UAAU;IACd;AACJ;;AAEA;IACI;QACI,UAAU;IACd;AACJ","sourcesContent":["/* Summary Page */\n.summary-container {\n    max-width: 900px;\n    margin: 2rem auto;\n    padding: 2rem;\n    background-color: #fff;\n    border-radius: 12px;\n    box-shadow: 0px 4px 12px rgba(0, 0, 0, 0.1);\n}\n\nh2 {\n    text-align: center;\n    font-size: 2rem;\n    color: var(--clr-primary-4);\n    margin-bottom: 2rem;\n}\n\n.back-button {\n    background-color: var(--clr-primary-5);\n    color: white;\n    border: none;\n    padding: 0.75rem 1.5rem;\n    border-radius: 8px;\n    cursor: pointer;\n    transition: background-color 0.3s ease;\n    margin-bottom: 1.5rem;\n}\n\n.back-button:hover {\n    background-color: var(--clr-primary-3);\n}\n\n.summary-section {\n    margin-bottom: 2rem;\n}\n\nh3 {\n    font-size: 1.5rem;\n    color: var(--clr-primary-3);\n    margin-bottom: 1rem;\n}\n\n/* Action Log List */\n.action-log-list {\n    list-style-type: none;\n    padding: 0;\n}\n\n.log-entry {\n    background-color: #f4f7f9;\n    padding: 1.5rem;\n    margin-bottom: 1rem;\n    border-left: 5px solid var(--clr-primary-3);\n    border-radius: 8px;\n    transition: background-color 0.3s ease, box-shadow 0.3s ease;\n}\n\n.log-entry:hover {\n    background-color: #eef2f7;\n    box-shadow: 0px 4px 8px rgba(0, 0, 0, 0.05);\n}\n\n.log-entry.cancelled {\n    background-color: #ffe6e6;\n    border-left: 5px solid #ff5c5c;\n}\n\n.log-details p {\n    margin: 0.5rem 0;\n}\n\n.log-details strong {\n    color: var(--clr-primary-3);\n}\n\n/* View Log Button */\n.view-log-button {\n    background-color: var(--clr-primary-5);\n    color: white;\n    border: none;\n    padding: 10px 20px;\n    cursor: pointer;\n    border-radius: 8px;\n    margin-top: 1.5rem;\n    transition: background-color 0.3s ease;\n}\n\n.view-log-button:hover {\n    background-color: var(--clr-primary-3);\n}\n\n/* Modal Styles */\n.modal {\n    position: fixed;\n    top: 50%;\n    left: 50%;\n    transform: translate(-50%, -50%);\n    z-index: 1000;\n    background-color: white;\n    padding: 2rem;\n    border-radius: 10px;\n    box-shadow: 0px 8px 24px rgba(0, 0, 0, 0.2);\n    width: 60%;\n    max-height: 70vh;\n    overflow-y: auto;\n}\n\n.modal-content {\n    flex-grow: 1;\n    padding: 1rem;\n}\n\n.modal ul {\n    list-style: none;\n    padding: 0;\n    margin: 0;\n}\n\n.modal ul li {\n    padding: 10px;\n    border-bottom: 1px solid #eee;\n}\n\n.close-button {\n    background-color: #ff5c5c;\n    color: white;\n    border: none;\n    padding: 8px 12px;\n    cursor: pointer;\n    border-radius: 50%;\n    font-size: 1.2rem;\n    position: absolute;\n    top: 15px;\n    right: 15px;\n}\n\n.close-button:hover {\n    background-color: #ff8787;\n}\n\n.modal-overlay {\n    position: fixed;\n    top: 0;\n    left: 0;\n    width: 100vw;\n    height: 100vh;\n    background: rgba(0, 0, 0, 0.5);\n    z-index: 999;\n}\n\n.recent-log-entry {\n    background-color: var(--clr-primary-10);\n    border-left: 4px solid var(--clr-primary-5);\n  }\n\n  \n/* Responsive Design */\n@media (max-width: 768px) {\n    .modal {\n        width: 90%;\n        max-height: 80vh;\n    }\n\n    .summary-container {\n        padding: 1rem;\n    }\n\n    .view-log-button, .back-button {\n        padding: 0.75rem 1rem;\n    }\n}\n\n@media (max-width: 768px) {\n    .close-button {\n        width: 10%;\n    }\n}\n\n@media (max-width: 480px) {\n    .close-button {\n        width: 10%;\n    }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
